import { createRouter, createWebHistory } from 'vue-router';
import paths from './path';
import { BasePaths } from '@/lib/const';
import cognito from '@/plugins/cognito';
import store from '@/store';
import { keepAlive } from '@/apis/common/keepAlive';
import { HttpStatus } from '@/lib/const';

// 接続先情報の取得
const BasePath = BasePaths;

function route(path, view, name, meta) {
  return {
    name: name || view,
    path,
    meta,
    component: resovle =>
      import(`@/pages/${BasePath}/${view}.vue`).then(resovle),
  };
}

const router = createRouter({
  history: createWebHistory(),
  routes: paths.map(path =>
    route(path.path, path.view, path.name, path.meta)
  ).concat([
    { path: '/important-matters', redirect: '/important_matter_list' },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ]),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { el: to.hash };
    }
    return { top: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const toPath = to.matched[0].path ? to.matched[0].path : to.path;
  const httpStatus = await keepAlive().catch(err => {
    return err;
  });
  if (to.name === 'Maintenance') {
    if (httpStatus && httpStatus !== HttpStatus.Maintenance) {
      // 通常時のメンテナンス画面へのアクセスはホーム画面にリダイレクト
      return next('/');
    }
  } else {
    if (httpStatus === HttpStatus.Maintenance) {
      // メンテナンス時はメンテナンス画面に遷移
      return next('/maintenance');
    }
  }

  if (cognitoNeedAuth(toPath)) {
    // ITa 開発バイパス: fake JWT（.ita-bypass-signature 末尾）が存在する場合は
    // Cognito 検証をスキップし、x-ita-user-id ヘッダー経由でユーザー情報を取得
    const clientId = process.env.VUE_APP_COGNITO_CLIENT_ID;
    const lastAuthUser = clientId
      ? localStorage.getItem(`CognitoIdentityServiceProvider.${clientId}.LastAuthUser`)
      : null;
    const accessToken = lastAuthUser
      ? localStorage.getItem(`CognitoIdentityServiceProvider.${clientId}.${lastAuthUser}.accessToken`)
      : null;
    const isItaBypass = accessToken && accessToken.endsWith('.ita-bypass-signature');

    if (!isItaBypass) {
      const isAuhthed = await cognito.isAuthenticated().catch(() => null);
      if (!isAuhthed) return next('/login');
    }

    // 権限チェック 参照権限を持たない場合、ホーム画面に遷移
    let userDetail = store.getters['user/userDetail'];

    // ユーザー情報がStoreに設定されていない場合、APIサーバーより所得
    if (!userDetail) {
      const currentCognitoUser = isItaBypass ? null : cognito.currentUser();
      const username = isItaBypass ? lastAuthUser : (currentCognitoUser && currentCognitoUser.username);
      if (!username) return next('/login');
      userDetail = await store.dispatch('user/getLoginUser', username);
    }
    const path = paths.find(e => e.path === toPath);

    if (!path.role.includes(userDetail.role)) return next('/');
  }

  next();
});

const cognitoNeedAuth = toPath => {
  const path = paths.find(e => e.path === toPath);
  return path ? path.meta.requiredAuth : false;
};

export default router;
